module.exports = __webpack_public_path__ + "img/dark-mode-icon.fc89af34.svg";